import { format, formatDistanceWithOptions } from 'date-fns/fp';

export const formatDate = format('yyyy-MM-dd');
export const formatTime = format('HH:mm');
export const formatDatetime = format("yyyy-MM-dd 'at' HH:mm");
export const formatDistance = formatDistanceWithOptions({
  includeSeconds: false,
  addSuffix: true,
});

const yearFormatter = new Intl.NumberFormat('en-US', {
  style: 'unit',
  unit: 'year',
  unitDisplay: 'long', // Options: 'long', 'short', 'narrow'
});

export function formatYear(nb: number) {
  return yearFormatter.format(nb);
}

export function formatLocalDateTime(date: Date, timezone: string): string {
  return new Intl.DateTimeFormat('default', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: timezone,
  }).format(date);
}
